import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { useNavigate } from "react-router-dom";
import "./AllLessons.css";
import { Link } from "react-router";
import { getStudentSubjects, getTeacherSubjects } from "../../redux/slices/subjectsSlice";
import { getSubjectLessons, getTeacherClasses, getTeacherClassLessons, getParentChildren, getChildLessons, getChildSubjects } from "../../redux/slices/lessonsSlice";
import { toast } from "react-toastify";
import AddLessonModal from "../../components/AddLessonModal/AddLessonModal";
import EditLessonModal from "../../components/AddLessonModal/EditLessonModal";
import DeleteLessonButton from "../../components/AddLessonModal/DeleteLessonButton";
import { FaEdit, FaTrash } from "react-icons/fa";


function AllLessons() {
  console.log("=== AllLessons Component Loaded ===");
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { studentSubjects, teacherSubjects, subjectsLoading } = useSelector((state) => state.subjects);
  const { subjectLessons, teacherClasses, teacherClassLessons, lessonsLoading, lessonsPagination, parentChildren, childLessons, childLessonsLoading, childSubjects, childSubjectsLoading } = useSelector((state) => state.lessons);
  const { currentUser } = useSelector((state) => state.auth);
  
  console.log("=== AllLessons Component Loaded ===");
  console.log("currentUser:", currentUser);
  console.log("userRole from localStorage:", localStorage.getItem("userRole"));
  
  const [activeTab, setActiveTab] = useState("الحصص المجانية");
  const [activeSubjectTab, setActiveSubjectTab] = useState(0);
  const [activeClassTab, setActiveClassTab] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isGuestMode, setIsGuestMode] = useState(true);
  const [isAddLessonModalOpen, setIsAddLessonModalOpen] = useState(false);
  const [isEditLessonModalOpen, setIsEditLessonModalOpen] = useState(false);
  const [selectedLessonToEdit, setSelectedLessonToEdit] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [showChildrenDropdown, setShowChildrenDropdown] = useState(false);
  const [selectedSubjectId, setSelectedSubjectId] = useState(0); // 0 = الكل افتراضياً

  const userRole = currentUser?.role || localStorage.getItem("userRole");
  const isTeacher = userRole === "teacher";
  const isParent = userRole === "parent";
  
  console.log("=== USER ROLE DEBUG ===");
  console.log("currentUser:", currentUser);
  console.log("currentUser?.role:", currentUser?.role);
  console.log("localStorage userRole:", localStorage.getItem("userRole"));
  console.log("userRole:", userRole);
  console.log("isParent:", isParent);
  console.log("isTeacher:", isTeacher);
  
  console.log("=== COMPONENT LOADED ===");
  console.log("userRole:", userRole);
  console.log("isTeacher:", isTeacher);
  console.log("isParent:", isParent);
  console.log("currentUser:", currentUser);

  useEffect(() => {
    console.log("=== useEffect 1 - window.scrollTo ===");
    window.scrollTo(0, 0);
  }, []);

  // التحقق من وجود token عند تحميل المكون
  useEffect(() => {
    console.log("=== useEffect 2 - Check Token ===");
    console.log("isTeacher:", isTeacher);
    console.log("isParent:", isParent);
    console.log("userRole:", userRole);
    
    const token = localStorage.getItem("token3almny");
    console.log("Token exists:", !!token);
    
          if (token) {
        setIsGuestMode(false);
        if (isTeacher) {
          console.log("Dispatching getTeacherClasses for teacher");
          dispatch(getTeacherClasses());
          dispatch(getTeacherSubjects());
        } else if (isParent) {
          console.log("Dispatching getParentChildren for parent");
          dispatch(getParentChildren());
        } else {
          console.log("Dispatching getStudentSubjects for student");
          dispatch(getStudentSubjects());
        }
      } else {
        setIsGuestMode(true);
      }
  }, [dispatch, isTeacher, isParent]);

  // تعيين الابن الأول وجلب مواده ودروسه (مثل FreeLessons.jsx)
  useEffect(() => {
    console.log("=== تعيين الابن الأول ===");
    console.log("isParent:", isParent);
    console.log("parentChildren:", parentChildren);
    console.log("selectedChild:", selectedChild);
    
    if (isParent && parentChildren && parentChildren.length > 0 && !selectedChild) {
      const firstChild = parentChildren[0];
      console.log("تعيين الابن الأول:", firstChild);
      setSelectedChild(firstChild);
      localStorage.setItem('selectedChildId', firstChild.id);
      // جلب مواد ودروس الابن الأول مباشرة
      console.log("جلب مواد الابن:", firstChild.id);
      dispatch(getChildSubjects(firstChild.id));
      console.log("جلب دروس الابن:", firstChild.id);
      dispatch(getChildLessons({ childId: firstChild.id, subjectId: 0 }));
    }
  }, [parentChildren, selectedChild, isParent, dispatch]);

  // جلب دروس الابن عند تغيير الابن أو المادة (مثل FreeLessons.jsx)
  useEffect(() => {
    console.log("=== جلب دروس الابن ===");
    console.log("isParent:", isParent);
    console.log("selectedChild:", selectedChild);
    console.log("selectedSubjectId:", selectedSubjectId);
    
    if (isParent && selectedChild) {
      console.log("استدعاء getChildLessons:", selectedChild.id, selectedSubjectId);
      dispatch(getChildLessons({ 
        childId: selectedChild.id, 
        subjectId: selectedSubjectId
      }));
    }
  }, [selectedChild, selectedSubjectId, dispatch, isParent]);

  // جلب الدروس عند تغيير المادة النشطة (للطلاب)
  useEffect(() => {
    if (!isGuestMode && !isTeacher && studentSubjects.length > 0 && activeTab === "الحصص المجانية") {
      const selectedSubject = studentSubjects[activeSubjectTab - 1];
      const subjectId = activeSubjectTab === 0 ? 0 : selectedSubject?.id;
      if (subjectId !== undefined) {
        dispatch(getSubjectLessons({ 
          subjectId: subjectId, 
          page: currentPage,
          freeStatus: true
        }));
      }
    }
  }, [activeSubjectTab, currentPage, studentSubjects, dispatch, isGuestMode, isTeacher, activeTab]);

  // جلب الدروس للحصص الاونلاين (للطلاب)
  useEffect(() => {
    if (!isGuestMode && !isTeacher && studentSubjects.length > 0 && activeTab === "حصص اونلاين") {
      const selectedSubject = studentSubjects[activeSubjectTab - 1];
      const subjectId = activeSubjectTab === 0 ? 0 : selectedSubject?.id;
      if (subjectId !== undefined) {
        dispatch(getSubjectLessons({ 
          subjectId: subjectId, 
          page: currentPage,
          videoType: 'online'
        }));
      }
    }
  }, [activeSubjectTab, currentPage, studentSubjects, dispatch, isGuestMode, isTeacher, activeTab]);

  // جلب الدروس للحصص المسجلة (للطلاب)
  useEffect(() => {
    if (!isGuestMode && !isTeacher && studentSubjects.length > 0 && activeTab === "حصص مسجلة") {
      const selectedSubject = studentSubjects[activeSubjectTab - 1];
      const subjectId = activeSubjectTab === 0 ? 0 : selectedSubject?.id;
      if (subjectId !== undefined) {
        dispatch(getSubjectLessons({ 
          subjectId: subjectId, 
          page: currentPage,
          videoType: 'offline'
        }));
      }
    }
  }, [activeSubjectTab, currentPage, studentSubjects, dispatch, isGuestMode, isTeacher, activeTab]);

  // جلب دروس المعلم حسب التاب النشط
  useEffect(() => {
    console.log("=== TEACHER USEFFECT DEBUG ===");
    console.log("isGuestMode:", isGuestMode);
    console.log("isTeacher:", isTeacher);
    console.log("teacherClasses.length:", teacherClasses.length);
    console.log("activeSubjectTab:", activeSubjectTab);
    console.log("activeTab:", activeTab);
    
    if (!isGuestMode && isTeacher && teacherClasses.length > 0) {
      let classId = 0; // افتراضياً للكل
      
      if (activeSubjectTab > 0) {
        const selectedClass = teacherClasses[activeSubjectTab - 1];
        if (selectedClass?.id !== undefined) {
          classId = selectedClass.id;
        }
      }
      
      let params = { classId, page: currentPage, perPage: 15 };
      
      if (activeTab === "الحصص المجانية") {
        params.freeStatus = 1;
      } else if (activeTab === "حصص اونلاين") {
        params.videoType = 'online';
      } else if (activeTab === "حصص مسجلة") {
        params.videoType = 'offline';
      }
      
      console.log("Dispatching getTeacherClassLessons with params:", params);
      dispatch(getTeacherClassLessons(params));
    }
  }, [activeSubjectTab, currentPage, teacherClasses, dispatch, isGuestMode, isTeacher, activeTab]);

  // الحصص المجانية الثابتة للـ Guest Mode
  const staticFreeLessons = [
    { id: 1, name: "اسم الحصة الدراسية", teacher: "احمد ابراهيم", subject: "علوم", students: "50+", files: 4, videos: 1, rating: 5, reviews: 21, image: "/science.png" },
    { id: 2, name: "الكيمياء للصف الأول", teacher: "محمد علي", subject: "كيمياء", students: "35+", files: 3, videos: 2, rating: 4, reviews: 15, image: "/courseimage.png" },
    { id: 3, name: "الرياضيات المتقدمة", teacher: "سعيد محمود", subject: "رياضيات", students: "60+", files: 5, videos: 3, rating: 5, reviews: 40, image: "/math.png" },
    { id: 4, name: "الأحياء التطبيقي", teacher: "ليلى حسن", subject: "أحياء", students: "45+", files: 4, videos: 2, rating: 5, reviews: 25, image: "/science.png" },
    { id: 5, name: "فيزياء القوى", teacher: "عمر خالد", subject: "فيزياء", students: "55+", files: 3, videos: 2, rating: 4, reviews: 18, image: "/physic.png" },
  ];

  // حصص الاونلاين الثابتة
  const staticOnlineLessons = [
    { id: 1, name: "أساسيات الكيمياء العضوية", teacher: "د. أحمد محمد", subject: "علوم", students: "450", files: 12, videos: 1, rating: 4, reviews: 128, image: "/courseimage.png" },
    { id: 2, name: "التاريخ الإسلامي الحديث", teacher: "د. فاطمة علي", subject: "الدراسات الاجتماعية", students: "320", files: 8, videos: 1, rating: 5, reviews: 89, image: "/courseimage.png" },
    { id: 3, name: "قواعد اللغة الإنجليزية المتقدمة", teacher: "أ. سارة أحمد", subject: "اللغة الإنجليزية", students: "280", files: 15, videos: 1, rating: 4, reviews: 156, image: "/courseimage.png" },
    { id: 4, name: "الجبر الخطي والمصفوفات", teacher: "د. محمد حسن", subject: "الرياضيات", students: "380", files: 20, videos: 1, rating: 5, reviews: 203, image: "/courseimage.png" },
    { id: 5, name: "جغرافيا العالم المعاصر", teacher: "د. خالد عبدالله", subject: "الجغرافيا", students: "210", files: 10, videos: 1, rating: 4, reviews: 95, image: "/courseimage.png" },
    { id: 6, name: "الفيزياء الكمية", teacher: "د. نورا سعيد", subject: "علوم", students: "290", files: 18, videos: 1, rating: 5, reviews: 167, image: "/courseimage.png" }
  ];

  // حصص مسجلة ثابتة
  const staticRecordedLessons = [
    { id: 1, name: "مقدمة في الكيمياء العضوية", teacher: "د. أحمد محمد", subject: "علوم", students: "320", files: 8, videos: 1, rating: 4, reviews: 95, image: "/courseimage.png" },
    { id: 2, name: "التاريخ الإسلامي - العصر الأموي", teacher: "د. فاطمة علي", subject: "الدراسات الاجتماعية", students: "280", files: 6, videos: 1, rating: 5, reviews: 67, image: "/courseimage.png" },
    { id: 3, name: "قواعد اللغة الإنجليزية الأساسية", teacher: "أ. سارة أحمد", subject: "اللغة الإنجليزية", students: "240", files: 12, videos: 1, rating: 4, reviews: 89, image: "/courseimage.png" },
    { id: 4, name: "الجبر الأساسي", teacher: "د. محمد حسن", subject: "الرياضيات", students: "350", files: 15, videos: 1, rating: 5, reviews: 156, image: "/courseimage.png" },
    { id: 5, name: "جغرافيا الوطن العربي", teacher: "د. خالد عبدالله", subject: "الجغرافيا", students: "180", files: 7, videos: 1, rating: 4, reviews: 45, image: "/courseimage.png" }
  ];



  // Mapping للأيقونات حسب اسم المادة
  const getSubjectIcon = (subjectTitle) => {
    const iconMap = {
      "الرياضيات": "/math.png",
      "الدراسات الاجتماعية": "/drasat.png",
      "اللغة العربية": "/arabic.png",
      "العلوم": "/science.png",
      "جغرافيا": "/gohraphia.png",
      "فيزياء": "/physic.png",
      "اللغة الإنجليزية": "/english.png",
      "تاريخ": "/tarekh.png",
      "اللغة الانجليزية": "/english.png",
    };
    return iconMap[subjectTitle] || "/science.png";
  };

  // تحويل الدروس إلى الشكل المطلوب للعرض
  const formatLessons = (lessons, subjectName) => {
    return lessons.map((lesson) => ({
      id: lesson.id,
      name: lesson.title,
      teacher: lesson.user_name,
      subject: (lesson.subject_name || subjectName || "").replace(/[\n\r]+/g, " ").trim(),
      students: "50+",
      files: 4,
      videos: 1,
      rating: lesson.rate || 0,
      reviews: lesson.love || 0,
      image: lesson.image,
      day: lesson.day,
      time: lesson.time,
      video_type: lesson.video_type
    }));
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setActiveSubjectTab(0);
    setCurrentPage(1);
  };

  const handleSubjectTabClick = (index) => {
    setActiveSubjectTab(index);
    setCurrentPage(1);
  };

  // دالة تغيير المادة لولي الأمر
  const handleSubjectChange = (subjectId) => {
    setSelectedSubjectId(subjectId);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleAddLessonSuccess = () => {
    // إعادة تحميل البيانات بعد إضافة حصة جديدة
    if (isTeacher) {
      dispatch(getTeacherClasses());
    } else {
      dispatch(getStudentSubjects());
    }
  };

  const handleEditLesson = (lesson) => {
    setSelectedLessonToEdit(lesson);
    setIsEditLessonModalOpen(true);
  };

  const handleEditLessonSuccess = () => {
    // إعادة تحميل الدروس بعد تعديل الحصة
    if (isTeacher) {
      if (selectedSubjectId === 0) {
        // إذا كان "الكل" محدد، جلب دروس الفصل الأول
        if (teacherClasses && teacherClasses.length > 0) {
          dispatch(getTeacherClassLessons({ 
            classId: teacherClasses[0].id, 
            page: currentPage,
            freeStatus: activeTab === "الحصص المجانية" ? 1 : undefined,
            videoType: activeTab === "حصص اونلاين" ? "online" : "offline"
          }));
        }
      } else {
        // إذا كان فصل محدد، جلب دروسه
        const selectedClass = teacherClasses[activeSubjectTab - 1];
        if (selectedClass) {
          dispatch(getTeacherClassLessons({ 
            classId: selectedClass.id, 
            page: currentPage,
            freeStatus: activeTab === "الحصص المجانية" ? 1 : undefined,
            videoType: activeTab === "حصص اونلاين" ? "online" : "offline"
          }));
        }
      }
    }
  };

  const handleDeleteLessonSuccess = () => {
    // إعادة تحميل الدروس بعد حذف الحصة
    handleEditLessonSuccess();
  };

  const handleDeleteLesson = async (lessonId) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        toast.error("يجب تسجيل الدخول أولاً");
        return;
      }

      const response = await fetch(`https://newalemny.3almny.app/api/lessons/delete_lesson/${lessonId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('تم حذف الدرس بنجاح');
        // تحديث الدروس
        if (isTeacher) {
          dispatch(getTeacherClassLessons({ 
            classId: activeClassTab === 0 ? 0 : teacherClasses[activeClassTab - 1]?.id,
            subjectId: activeSubjectTab === 0 ? 0 : teacherSubjects[activeSubjectTab - 1]?.id
          }));
        }
      } else {
        toast.error(data.message || 'فشل في حذف الدرس');
      }
    } catch (error) {
      console.error('Error deleting lesson:', error);
      toast.error('حدث خطأ في الاتصال بالخادم');
    }
  };

  // تحديد البيانات التي سيتم عرضها (مثل FreeLessons.jsx)
  let tabsData = [];
  let lessonsToShow = staticFreeLessons;

  console.log("=== DEBUG LESSONS DATA ===");
  console.log("isGuestMode:", isGuestMode);
  console.log("isParent:", isParent);
  console.log("childLessons:", childLessons);
  console.log("childLessons?.data:", childLessons?.data);
  console.log("childLessons?.data?.length:", childLessons?.data?.length);

  if (!isGuestMode) {
    if (isParent) {
      // لولي الأمر: عرض دروس الابن المختار
      tabsData = childSubjects || [];
      const rawData = childLessons?.data || [];
      console.log("Raw data before formatLessons:", rawData);
      lessonsToShow = formatLessons(rawData, "");
      console.log("Parent Mode - All Lessons");
      console.log("childLessons:", childLessons);
      console.log("childLessons.data:", childLessons?.data);
      console.log("lessonsToShow:", lessonsToShow);
      console.log("lessonsToShow.length:", lessonsToShow.length);
    } else if (isTeacher) {
      tabsData = teacherClasses;
      lessonsToShow = formatLessons(teacherClassLessons?.data || [], "");
      console.log("Teacher Mode - All Lessons");
    } else {
      tabsData = Array.isArray(studentSubjects) ? studentSubjects : [];
      lessonsToShow = formatLessons(subjectLessons || [], Array.isArray(studentSubjects) ? studentSubjects[activeSubjectTab - 1]?.title : "");
      console.log("Student Mode - All Lessons");
    }
  }

  const mainTabs = ["الحصص المجانية", "حصص اونلاين", "حصص مسجلة"];

  return (
    <div className={`all-lessons-page ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="container">
        {/* Breadcrumb */}
        <div className="lessons-breadcrumb">
          <h1 className="breadcrumb-title">الحصص الدراسية</h1>
          <div className="breadcrumb-links2">
            <span className="breadcrumb-link">الرئيسية</span>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">الحصص الدراسية</span>
          </div>
        </div>

        {/* Title and Add Lesson Button */}
        <div className="d-flex justify-content-between align-items-center mb-4">
         
          
          {/* Children Dropdown for Parents */}
          {isParent && parentChildren && parentChildren.length > 0 && (
            <div className="children-selector">
              <div className="dropdown-container">
                <button 
                  className="dropdown-button"
                  onClick={() => setShowChildrenDropdown(!showChildrenDropdown)}
                >
                  <span>{selectedChild ? selectedChild.name : 'اختر الابن'}</span>
                  <i className={`fas fa-chevron-down dropdown-icon ${showChildrenDropdown ? 'rotated' : ''}`}></i>
                </button>
                
                {showChildrenDropdown && (
                  <div className="dropdown-menu">
                    {parentChildren.map((child) => (
                      <button
                        key={child.id}
                        className={`dropdown-item ${selectedChild?.id === child.id ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedChild(child);
                          setShowChildrenDropdown(false);
                          localStorage.setItem('selectedChildId', child.id);
                          setCurrentPage(1);
                          setSelectedSubjectId(0); // إعادة تعيين المادة إلى الكل
                        }}
                      >
                        {child.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {isTeacher && (
            <button
              className="btn btn-primary add-lesson-btn"
              onClick={() => {
                console.log('isGuestMode:', isGuestMode);
                console.log('Setting modal to open');
                setIsAddLessonModalOpen(true);
              }}
            >
              + إضافة حصة دراسية
            </button>
          )}
        </div>

        {/* Main Tabs */}
        {!isParent && (
          <div className="lessons-tabs">
            <div className="tabs-header">
              <span className="subjects-text">أنواع الحصص</span>
              <div className="tabs-container">
                {mainTabs.map((tab) => (
                  <button
                    key={tab}
                    className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                    onClick={() => handleTabClick(tab)}
                  >
                    {tab}
                  </button>
                ))}
              </div>

            </div>
          </div>
        )}

        {/* Tabs المواد لولي الأمر */}
        {isParent && !isGuestMode && selectedChild && (
          <div className="subjects-tabs mt-3">
            <div className="tabs-container">
              {/* خيار الكل */}
              <button
                className={`subject-tab ${selectedSubjectId === 0 ? 'active' : ''}`}
                onClick={() => handleSubjectChange(0)}
              >
                <img 
                  src="/science.png" 
                  alt="الكل" 
                  className="tab-icon" 
                />
                <span>الكل</span>
              </button>
              
              {/* باقي المواد */}
              {childSubjects && childSubjects.length > 0 && childSubjects.map((subject) => (
                <button
                  key={subject.id}
                  className={`subject-tab ${selectedSubjectId === subject.id ? 'active' : ''}`}
                  onClick={() => handleSubjectChange(subject.id)}
                >
                  <img 
                    src="/courseimage.png" 
                    alt={subject.title} 
                    className="tab-icon" 
                  />
                  <span>{subject.title}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Subject/Class Tabs */}
        {(activeTab === "الحصص المجانية" || activeTab === "حصص اونلاين" || activeTab === "حصص مسجلة") && !isGuestMode && !isParent && (
          <div className="subjects-tabs mt-3">
            <div className="tabs-container">
              {/* خيار الكل */}
              <button
                className={`subject-tab ${activeSubjectTab === 0 ? 'active' : ''}`}
                onClick={() => handleSubjectTabClick(0)}
              >
                <img 
                  src="/science.png" 
                  alt="الكل" 
                  className="tab-icon" 
                />
                <span>الكل</span>
              </button>
              
              {/* باقي المواد/الفصول */}
              {(isTeacher ? teacherClasses : studentSubjects).map((item, index) => (
                <button
                  key={item.id}
                  className={`subject-tab ${activeSubjectTab === index + 1 ? 'active' : ''}`}
                  onClick={() => handleSubjectTabClick(index + 1)}
                >
                  <img 
                    src={getSubjectIcon(isTeacher ? item.name : item.title)} 
                    alt={isTeacher ? item.name : item.title} 
                    className="tab-icon" 
                  />
                  <span>{isTeacher ? item.name : item.title}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Loading State */}
        {(activeTab === "الحصص المجانية" || activeTab === "حصص اونلاين" || activeTab === "حصص مسجلة") && !isGuestMode && lessonsLoading && (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">جاري التحميل...</span>
            </div>
          </div>
        )}

        {/* Lessons Grid */}
        {lessonsToShow.length > 0 ? (
          <>
            <div className="lessons-grid">
              {lessonsToShow.map((lesson) => (
                <div key={lesson.id} className="lesson-card shadow-sm">
                  {/* Header */}
                  <div 
                    className="lesson-header lesson-image-overlay" 
                    style={{ 
                      backgroundImage: isGuestMode
                        ? `url('/courseimage.png')`
                        : lesson.image
                          ? `url(${lesson.image})`
                          : `url('/courseimage.png')`,
                      height: "200px" 
                    }}
                  >
                    {isTeacher && (
                      <div className="image-actions">
                        <button 
                          className="edit-icon"
                          onClick={() => handleEditLesson(lesson)}
                          title="تعديل الدرس"
                          type="button"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="delete-icon"
                          onClick={() => {
                            if (window.confirm(`هل أنت متأكد من حذف الدرس "${lesson.name}"؟`)) {
                              // حذف مباشر بدون مودل
                              handleDeleteLesson(lesson.id);
                            }
                          }}
                          title="حذف الدرس"
                          type="button"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Body */}
                  <div className="lesson-body">
                    <div className="rating">
                      <span className="reviews">({lesson.reviews})</span>
                      <span className="stars">{"★".repeat(lesson.rating)}</span>
                    </div>
                    <h5 className="lesson-name mb-3">{lesson.name}</h5>
                    <div className="lesson-info">
                      <span style={{ fontSize: "12px" }}>👥 {lesson.students} طالب</span>
                      <span style={{ fontSize: "12px" }}>📄 +{lesson.files} ملفات</span>
                      <span style={{ fontSize: "12px" }}>🎥 فيديو شرح</span>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="lesson-footer align-items-center mb-2">
                    <div className="teacher">
                      <img src="/user.png" alt="3almny Academy" className="teacher-img" />
                      <span style={{ fontSize: "12px" }} className="teacher mx-2">
                        {lesson.teacher || "معلم"}
                      </span>
                    </div>
                    {lesson.subject && lesson.subject.trim() !== "" && (
                      <span style={{ fontSize: "12px" }} className="subject mt-3">
                        {lesson.subject}
                      </span>
                    )}
                  </div>

                  {/* Action Buttons for Teachers */}
                  {isTeacher && (
                    <div className="lesson-actions">
                      <Link to={`/lessonDetails/${lesson.id}`} className="view-btn">
                        عرض التفاصيل
                      </Link>
                    </div>
                  )}

                  {/* View Button for Non-Teachers */}
                  {!isTeacher && (
                    <div className="lesson-actions">
                      <Link to={`/lessonDetails/${lesson.id}`} className="view-btn">
                        عرض التفاصيل
                      </Link>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Pagination */}
            {(activeTab === "الحصص المجانية" || activeTab === "حصص اونلاين" || activeTab === "حصص مسجلة") && !isGuestMode && (
              (isTeacher ? teacherClassLessons?.pagination : (isParent ? childLessons?.pagination : lessonsPagination)) && 
              (isTeacher ? teacherClassLessons.pagination.pages_count : (isParent ? childLessons.pagination.pages_count : lessonsPagination.pages_count)) >= 1 && (
                <div className="pagination-container mt-4">
                  <div className="pagination">
                    {Array.from({ 
                      length: isTeacher 
                        ? teacherClassLessons.pagination.pages_count 
                        : (isParent ? childLessons.pagination.pages_count : lessonsPagination.pages_count)
                    }, (_, i) => i + 1).map((page) => (
                      <button
                        key={page}
                        className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    ))}
                  </div>
                </div>
              )
            )}
          </>
        ) : (
          <div className="text-center mx-auto justify-content-center d-flex my-4">
            <div className="no-lessons-message">
              <div className="no-lessons-icon">📚</div>
              <h4>لا توجد حصص متاحة</h4>
              <p>لا توجد حصص متاحة في هذا القسم حالياً</p>
            </div>
          </div>
        )}
      </div>
      
      {/* Modal إضافة حصة دراسية */}
      <AddLessonModal
        isOpen={isAddLessonModalOpen}
        onClose={() => setIsAddLessonModalOpen(false)}
        lessonType={activeTab}
        onSuccess={handleAddLessonSuccess}
      />

      {/* Modal تعديل الحصة الدراسية */}
      <EditLessonModal
        isOpen={isEditLessonModalOpen}
        onClose={() => {
          setIsEditLessonModalOpen(false);
          setSelectedLessonToEdit(null);
        }}
        lesson={selectedLessonToEdit}
        onSuccess={handleEditLessonSuccess}
      />
    </div>
  );
}

export default AllLessons;